export default "__VITE_ASSET__81559906__"